<template>
  <AppViewContainer>
    <div class="settlement-google-sheets-view__card">
      <GoogleSheetsConfig />
    </div>
    <div class="settlement-google-sheets-view__card">
      <PickupGoogleSheetsConfig />
    </div>
    <div class="settlement-google-sheets-view__card">
      <SheetBackupDownload />
    </div>
    <div class="settlement-google-sheets-view__card">
      <CancelledDeliveriesDriverConfig />
    </div>
  </AppViewContainer>
</template>

<script>
import AppViewContainer from '../components/UI/AppViewContainer'
import GoogleSheetsConfig from '../components/settlement/GoogleSheetsConfig'
import PickupGoogleSheetsConfig from '../components/settlement/PickupGoogleSheetsConfig'
import SheetBackupDownload from '../components/settlement/SheetBackupDownload'
import CancelledDeliveriesDriverConfig from '../components/settlement/CancelledDeliveriesDriverConfig'

export default {
  name: 'SettlementGoogleSheetsConfigView',
  components: {
    AppViewContainer,
    GoogleSheetsConfig,
    PickupGoogleSheetsConfig,
    SheetBackupDownload,
    CancelledDeliveriesDriverConfig
  }
}
</script>

<style scoped>
.settlement-google-sheets-view__card {
  margin-top: 1rem;
  padding: 1.5rem;
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
</style>
